"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { Button } from "./ui";

const SAMPLES = [
  "https://www.amazon.com/dp/B0C1EXAMPLE",
  "https://shop.example.com/products/portable-coffee",
  "https://www.tiktok.com/view/product/1729382716",
];

const SAMPLE_LABELS = ["Amazon sample", "Shopify sample", "TikTok Shop sample"];

export function HeroInput() {
  const router = useRouter();
  const [url, setUrl] = useState("");

  function go(value: string) {
    const v = value.trim();
    router.push(v ? `/studio?url=${encodeURIComponent(v)}` : "/studio");
  }

  return (
    <div className="mx-auto mt-10 max-w-2xl">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          go(url);
        }}
        className="flex flex-col gap-2.5 rounded-2xl border border-line-strong bg-white/[0.06] p-2.5 backdrop-blur-sm sm:flex-row sm:items-center sm:rounded-full sm:p-2"
      >
        <input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Paste a product link, e.g. https://www.amazon.com/dp/..."
          className="min-w-0 flex-1 bg-transparent px-4 py-3 text-sm outline-none placeholder:text-white/35"
        />
        <Button type="submit" size="lg" className="shrink-0">
          Generate video →
        </Button>
      </form>
      <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-xs text-muted">
        <span>No link handy? Try</span>
        {SAMPLES.map((s, i) => (
          <button
            key={s}
            type="button"
            onClick={() => go(s)}
            className="rounded-full border border-line px-3 py-1.5 transition hover:border-[var(--border-strong)] hover:text-foreground"
          >
            {SAMPLE_LABELS[i]}
          </button>
        ))}
      </div>
    </div>
  );
}
